let scrollContainerLogos = document.querySelector('.detailed-icon-panel .grid-x');
let scrollItems = document.querySelectorAll('.detailed-icon-panel .grid-x .cell');

let customSliderObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if(entry.isIntersecting){
      setSliderBullets(Number(entry.target.dataset.customBullet));
    }
  })
}, {
  root: scrollContainerLogos,
  threshold: 0.25,
})

scrollItems.forEach(slide => {
  customSliderObserver.observe(slide);
})

function setSliderBullets(number){
  document.querySelectorAll('.custom-slider-bullets .custom-bullet').forEach(bullet => {
    bullet.classList.remove('current');
    if(Number(bullet.dataset.customBullet) === number) bullet.classList.add('current');
  })
}